import Slider from '@react-native-community/slider';
import React from 'react';
import { Platform, StyleProp, StyleSheet, ViewStyle } from 'react-native';
import Theme from '../../theme';

interface ISliderGaugeProps {
  onValueChange: (value: number) => void;
  onSlidingComplete?: (value: number) => void;
  initialValue: number;
  minimumValue: number;
  maximumValue: number;
  step: number;
  minimumTrackTintColor: string;
  maximumTrackTintColor: string;
  thumbTintColor?: string;
  inverted?: boolean;
  style: StyleProp<ViewStyle>;
}

const useOrangeSliderButton  = Platform.OS  === 'android' || Platform.OS === 'web';

export const SliderGauge = ({
  style = styles.defaultContainerStyle,
  inverted = false,
  onValueChange,
  initialValue,
  maximumValue,
  minimumValue,
  step,
  thumbTintColor = useOrangeSliderButton ? Theme.PRIMARY : Theme.WHITE,
  minimumTrackTintColor,
  maximumTrackTintColor,
  onSlidingComplete,
}: ISliderGaugeProps) => {
  return (
    <Slider
      style={style}
      onValueChange={onValueChange}
      value={initialValue}
      thumbTintColor={thumbTintColor}
      minimumValue={minimumValue}
      maximumValue={maximumValue}
      onSlidingComplete={onSlidingComplete}
      step={step}
      minimumTrackTintColor={minimumTrackTintColor}
      maximumTrackTintColor={maximumTrackTintColor}
      inverted={inverted}
    />
  );
};

const styles = StyleSheet.create({
  defaultContainerStyle: {
    width: '100%',
    height: '100%',
  },
});
